<template>

  <b-modal v-model="showDateModal" :width="450" scroll="clip" animation="zoom-out" :can-cancel="false">

    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Date</p>
        <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
      </header>

      <section class="modal-card-body">

        <b-field
            :type="invalidFields.date == ''? 'is-info' : 'is-danger'"
            :message="invalidFields.date"
        >
          <b-datepicker v-model="date"
                        inline
                        @input="resetInvalidFields('date')"
                        :unselectable-days-of-week="[0, 6]"
                        :max="maxDate"
                        icon="calendar-today"
                        
                editable>
          </b-datepicker>
        </b-field>

        <div class="buttons">
          <b-button type="is-primary" outlined rounded expanded @click="addDate()">Add Date</b-button>
        </div>

      </section>

    </div>
  </b-modal>

</template>

<script>

export default {

  name:'enter-date',

  props:{

  },

  data() {
    return {
      showDateModal : true,

      date: null, // initially set to null

      invalidFields:{
        date: "",
      },
      now : new Date(),
      today:null,
      maxDate:null,
     
    }
  },

  methods:{

    /**
     * A method to reset invalid form fields
     * @param field field name
     */
    resetInvalidFields : function(field){
      this.invalidFields[field] =''
    },


    /**
     * A method to validate the input fields
     * @returns {boolean}
     */
    validateFields(){
      var isValid = true
      const comp = this

      if(comp.date == null){
        comp.invalidFields.date = "Please pick a date"
        isValid = false
      }

      return isValid
    },


    /**
     * This method is used to emit a custom event with selected date
     */
    addDate(){

      const comp = this

      if(comp.validateFields()){

        let month = comp.date.getMonth()+1

        if(month < 10){
          month = "0"+month
        }
        var formattedDate = comp.date.getFullYear()+"-"+month +"-"+comp.date.getDate()

        console.log("Selected Date : "+comp.date.toLocaleString())
        console.log("Selected Date (Formatted) : "+formattedDate)

        comp.$emit('on-date-added',formattedDate) // TODO :: emit an event on date added
      }

    },

  },

  mounted() {
    this.today =new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate()),
      this.maxDate =new Date(this.today)
  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}

</style>
